import React from 'react'
import { Button } from '@frontend/pole-ui/lib/components/Button'
import { messages } from '@/components/composed/pwa/Notification/components/messages'
import type { IPlatformProps } from '../types'
import '../styles.scss'

export const Ios = (props: IPlatformProps) => {
  const { onActionButtonClick } = props

  return (
    <>
      <h3 className={'notification__header'}>{messages.iOs.header}</h3>
      <p className={'notification__text'}>{messages.iOs.text}</p>
      <ol className={'notification__list'}>
        {messages.iOs.items.map(item => (
          <li className={'notification__text'} key={item.value}>
            {item.value}
          </li>
        ))}
      </ol>
      <Button modifiers={['full-width-always', 'green']} onClick={onActionButtonClick} className={'notification__actionButton'}>
        {messages.iOs.buttonLabel}
      </Button>
    </>
  )
}
